















































































import Vue from 'vue';
import { OutlinedSelect } from '@/components/ds';
import ProuniFileUpload from '@/components/forms/prouni/ProuniFileUpload.vue';
import { toYesNoLabel, YES_LABEL, NO_LABEL } from '@/helpers/prouniOptions';
import {
  InstitutionType,
  ProuniApplication,
  ProuniDocumentType,
} from '@/store/modules/prouni/types';

const YES = YES_LABEL;
const NO = NO_LABEL;

export default Vue.extend({
  name: 'ProuniEducationForm',
  components: { OutlinedSelect, ProuniFileUpload },
  props: {
    application: {
      type: Object as () => ProuniApplication | null,
      default: null,
    },
  },
  data() {
    const app = this.application || {};
    const isTeacher =
      typeof app.isPublicSchoolTeacher === 'boolean' ? app.isPublicSchoolTeacher : undefined;
    const hasDisability = typeof app.hasDisability === 'boolean' ? app.hasDisability : undefined;
    return {
      form: {
        institutionType: app.institutionType || '',
        isPublicSchoolTeacher: isTeacher,
        hasDisability,
      },
      institutionValue: '',
      teacherValue: toYesNoLabel(isTeacher),
      disabilityValue: toYesNoLabel(hasDisability),
      documentTypes: ProuniDocumentType,
      uploaded: {
        certificate: (app.documents || []).some(
          d => d.documentType === ProuniDocumentType.highSchoolCertificate,
        ),
        transcript: (app.documents || []).some(
          d => d.documentType === ProuniDocumentType.highSchoolTranscript,
        ),
        teacher: (app.documents || []).some(
          d => d.documentType === ProuniDocumentType.teacherProof,
        ),
        disability: (app.documents || []).some(
          d => d.documentType === ProuniDocumentType.disabilityReport,
        ),
      },
    };
  },
  computed: {
    institutionOptions(): string[] {
      return [
        this.$t('prouni.education.public') as string,
        this.$t('prouni.education.private') as string,
      ];
    },
    yesNoOptions(): string[] {
      return [YES, NO];
    },
  },
  created() {
    this.institutionValue = this.institutionLabel(this.form.institutionType);
  },
  mounted() {
    // Emit the initial validity so revisiting a step (already filled) enables Continue.
    this.inputHandler();
  },
  methods: {
    institutionLabel(type?: string): string {
      if (type === InstitutionType.public) return this.$t('prouni.education.public') as string;
      if (type === InstitutionType.private) return this.$t('prouni.education.private') as string;
      return '';
    },
    setUploaded(kind: 'certificate' | 'transcript' | 'teacher' | 'disability', value: boolean) {
      this.uploaded[kind] = value;
      this.inputHandler();
    },
    institutionHandler(value: string) {
      this.form.institutionType =
        value === (this.$t('prouni.education.public') as string)
          ? InstitutionType.public
          : InstitutionType.private;
      this.inputHandler();
    },
    teacherHandler(value: string) {
      this.form.isPublicSchoolTeacher = value === YES;
      this.inputHandler();
    },
    disabilityHandler(value: string) {
      this.form.hasDisability = value === YES;
      this.inputHandler();
    },
    inputHandler() {
      const teacherOk = !this.form.isPublicSchoolTeacher || this.uploaded.teacher;
      const disabilityOk = !this.form.hasDisability || this.uploaded.disability;

      const isValid = Boolean(
        this.form.institutionType &&
          this.uploaded.certificate &&
          this.uploaded.transcript &&
          typeof this.form.isPublicSchoolTeacher === 'boolean' &&
          typeof this.form.hasDisability === 'boolean' &&
          teacherOk &&
          disabilityOk,
      );

      this.$emit('input', { ...this.form }, isValid);
    },
  },
});
